import type { BooleanString, PoiCategoryTrackerName } from '$lib/services/tracking/googleAnalytics/events';

export type MetaPixelAction = 'Lead' | 'PageView' | 'ViewContent';

export const metaPixelActions = {
	LEAD: 'Lead',
	PAGE_VIEW: 'PageView',
	VIEW_CONTENT: 'ViewContent',
} satisfies Record<string, MetaPixelAction>;

export interface MetaDatasheetViewContentPayload {
	content_category: PoiCategoryTrackerName;
	michelin_selection: BooleanString;
}

export interface MetaBookLeadPayload {
	content_category: PoiCategoryTrackerName;
}

export interface MetaDatasheetViewContentEvent {
	action: typeof metaPixelActions['VIEW_CONTENT'];
	payload: MetaDatasheetViewContentPayload;
}

export interface MetaBookLeadEvent {
	action: typeof metaPixelActions['LEAD'];
	payload: MetaBookLeadPayload;
}

export interface MetaPageViewEvent {
	action: typeof metaPixelActions['PAGE_VIEW'];
}

export type MetaPixelTrackingEvents = MetaPageViewEvent | MetaDatasheetViewContentEvent | MetaBookLeadEvent;
